module.exports = __webpack_public_path__ + "img/limon.34f1ebaf.gif";